<p-divider />

<div class="h-[80vh] w-full flex flex-col relative">
  @if (safeUrl) {
    <div class="flex-1 overflow-hidden">
      <object [data]="safeUrl" type="application/pdf" class="w-full h-full">
        <p>Preview not supported. Please download the file.</p>
      </object>
    </div>
  }

  <p-divider />

  <div class="flex justify-end gap-2">
    <p-button
      [label]="'common.close' | transloco"
      severity="primary"
      (onClick)="onCloseDialog()"
    ></p-button>
  </div>
</div>
